import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createBootstrap } from "bootstrap-vue-next";
import ToolTipDirective from "./components/ToolTipDirective.js";
import clearZero from "./directives/clearZero.js";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";

import "admin-lte/dist/css/adminlte.min.css";
import "admin-lte/dist/js/adminlte";
import "bootstrap/dist/js/bootstrap.bundle";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { LoadingPlugin } from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import "./scss/index";

import axios from "axios";
import { useAuthStore } from "@/store/auth";
import { useToast } from "vue-toastification";
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

//custom styles
import "./assets/css/style.css"

const app = createApp(App);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.use(createBootstrap());
app.use(router);

app.use(Toast);
app.use(LoadingPlugin, {
    color: "#489464",
    loader: "spinner",
});
app.use(VueSweetalert2)

app.directive("tooltip", ToolTipDirective());
app.directive("clear-zero", clearZero);
app.mount("#app");

const auth = useAuthStore();
const toast = useToast();
axios.interceptors.response.use(
    (response) => {
        if (response.data && response.data.status === false) {
            toast.error(response.data.message || "An error occurred. Please try again");
        }
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            auth.logout();
            toast.warning("Your session has expired. Please log in again");
            router.push("/login");
            return Promise.resolve({ data: {} });
        } else {
            toast.error("An error occurred. Please try again");
            return Promise.resolve({ data: {} });
        }
    }
);
